const DeleteIcon = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8825 6.30469C12.8825 6.30469 12.5205 10.7947 12.3105 12.686C12.2105 13.5894 11.6525 14.1187 10.7385 14.1354C8.99921 14.1667 7.25788 14.1687 5.51921 14.132C4.63987 14.114 4.09121 13.578 3.99321 12.6907C3.78188 10.7827 3.42188 6.30469 3.42188 6.30469" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.8053 4.15365H2.5" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6264 4.15413C11.1031 4.15413 10.6524 3.78413 10.5497 3.27146L10.3877 2.46079C10.2877 2.08679 9.94907 1.82812 9.56307 1.82812H6.74107C6.35507 1.82812 6.0164 2.08679 5.9164 2.46079L5.7544 3.27146C5.65173 3.78413 5.20107 4.15413 4.67773 4.15413" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default DeleteIcon